import { useEffect, useState } from 'react';

import { Collapse } from '@mui/material';
import { ListItemButton, ListItemText, StyledExpand, StyledListItem, Wrapper } from '@styles/Admin-tools/Workflows/WorkflowsStyle';

import { IWorkflow, IWorkflowStep } from '../../types';
import { CollapseItem } from './components/CollapseItem/CollapseItem';

type TCustomListProps = {
  handleChangeDestStep: (step: IWorkflowStep | null) => void;
  selectedWorkflow?: IWorkflow | null;
  defaultSelectedStep?: string;
  stepData?: IWorkflowStep | null;
};

const CustomList = ({ handleChangeDestStep, stepData, selectedWorkflow, defaultSelectedStep }: TCustomListProps) => {
  const [selectedWorkflowId, setSelectedWorkflowId] = useState<string>(selectedWorkflow?.workflowId ?? '');
  const [currentStep, setCurrentStep] = useState<IWorkflowStep | null>(stepData ? {...stepData, id: stepData?.reRouteWorkflowStepId ?? '', stepPath: stepData?.reRouteDetails?.stepName} : null);

  useEffect(() => {
    handleChangeDestStep(currentStep);
  }, [currentStep]);

  const handleChangeCheckbox = (step: IWorkflowStep | null) => {
    setCurrentStep(step);
    handleChangeDestStep(step);
  };

  return (
    <Wrapper padding="10px 0">
      {selectedWorkflow && (
        <StyledListItem>
          <ListItemButton onClick={() => setSelectedWorkflowId(!selectedWorkflowId ? selectedWorkflow.workflowId : '' )}>
            <StyledExpand isOpen={selectedWorkflow.workflowId === selectedWorkflowId} />

            <ListItemText>{selectedWorkflow.workflowName}</ListItemText>
          </ListItemButton>

          <Collapse unmountOnExit in={selectedWorkflow.workflowId === selectedWorkflowId} timeout="auto">
            {selectedWorkflow?.workflowSteps?.map((item) => (
              <CollapseItem
                key={item.id}
                stepData={item}
                handleChangeCheckbox={handleChangeCheckbox}
                selectedStep={currentStep}
                defaultSelectedStep={defaultSelectedStep}
              />
            ))}
          </Collapse>
        </StyledListItem>
      )}
    </Wrapper>
  );
};

export default CustomList;
